import dialogControl from './dialog-control';

export default {
  dialogControl,
};
